export const TELMEX_REGISTER = 'TELMEX_REGISTER';
export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const OTHERS = 'OTHERS';
export const REGISTRATE = 'registarte con tu correo';
export const LANDING = 'landing';
export const INICIASESION = 'inicia sesion';
export const TELMEX = 'telmex';

const typeModal = {
    [TELMEX_REGISTER]: {
        icon_header: 'Onboarding2_Logo_ClaroVideoTelmex',
        title: 'Onboarding2_RegistroOTP_Texto_Titulo_UsuarioTelmex',
        step_1: 'Onboarding2_RegistroOTP_Texto_Parrafo1_Paso1_UsuarioTelmex',
        step_1_complement: 'Onboarding2_RegistroOTP_Texto_Parrafo2_Paso1_UsuarioTelmex',
        step_2: 'Onboarding2_RegistroOTP_Texto_Parrafo_Paso2_UsuarioTelmex',
        step_3: 'Onboarding2_RegistroOTP_Texto_Parrafo_Paso3_UsuarioTelmex',
    },
    [LOGIN]: {
        icon_header: 'Onboarding2_Logo_ClaroVideo',
        title: 'Onboarding2_IniciaSesionOTP_Texto_Titulo',
        step_1: 'Onboarding2_IniciaSesionOTP_Texto_Parrafo1_Paso1',
        step_1_complement: 'Onboarding2_IniciaSesionOTP_Texto_Parrafo2_Paso1',
        step_2: 'Onboarding2_IniciaSesionOTP_Texto_Parrafo_Paso2',
        step_3: 'Onboarding2_IniciaSesionOTP_Texto_Parrafo_Paso3',
    },
    [REGISTER]: {
        icon_header: 'Onboarding2_Logo_ClaroVideo',
        title: 'Onboarding2_RegistroOTP_Texto_Titulo',
        step_1: 'Onboarding2_RegistroOTP_Texto_Parrafo1_Paso1',
        step_1_complement: 'Onboarding2_RegistroOTP_Texto_Parrafo2_Paso1',
        step_2: 'Onboarding2_RegistroOTP_Texto_Parrafo_Paso2',
        step_3: 'Onboarding2_RegistroOTP_Texto_Parrafo_Paso3',
    },
}


export const getTypeModal = (modalType) => {
    return typeModal[modalType] || typeModal[TELMEX_REGISTER];
}


// WEBPACK FOOTER //
// ./src/components/Modal/LoginQR/const.js